import { SportEventRegistrationStatus } from "../models/sport-events.model";

export function registrationStatusVariantFilter(sportEventStatus: SportEventRegistrationStatus) {
  switch (sportEventStatus.code) {
    case "apply":
      return "success";
    case "finished":
      return "dark";
    case "modifiable":
      return "warning";
  }
}
